// @flow
import React from 'react';
import { Image } from 'components/atoms/image';
import Col from 'react-bootstrap/Col';

export const BannerImageLayout = props => {
  const {
    thumbNailUrl = '',
    bannerClassNames = '',
    imageUrl,
    altImageName = 'banner',
    imageId,
    variableWidth,
    titleHeading,
    textClassNames,
    title,
  } = props;
  return (
    <>
      <Image
        thumbNail={thumbNailUrl}
        className={bannerClassNames}
        src={imageUrl}
        alt={altImageName ? altImageName : 'banner'}
        isHoveredImagePresent={true}
        keyChange={imageId}
      />
      {title && (
        <React.Fragment>
          <Col
            className={'banner-title'}
            xs={{ span: 9 }}
            md={{ span: 6 }}
            lg={{ span: variableWidth ? 6 : 5 }}
          >
            <Col xs={{ span: 9 }} md={{ span: 10 }} lg={{ span: 10 }}>
              {titleHeading && (
                <h3 className={'heading-text'}>{titleHeading}</h3>
              )}
            </Col>
            <h1 className={textClassNames}>{title}</h1>
          </Col>
        </React.Fragment>
      )}
    </>
  );
};
